export const COLOR_PALETTE_LABEL = 'Color Palette';
export const COLOR_PALETTE_PLACEHOLDER = 'Select A Palette';
export const DEFAULT_NUM_DISPLAY_COLORS = 6;
